// extracted by mini-css-extract-plugin
export default {"margin":"12","border":"2","outer":"dropdownContext_outer__lXSNA"};